import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const GetHomePageRevisionsURL = '/home_page_revisions'

const homePageRevisionEndPoint = {
  getHomePageRevisions: (params: any) => {
    return axiosRequest().get(GetHomePageRevisionsURL, { params })
  },
}

const homePageAPI = {
  getHomePageRevisions: (params = {}) =>
    apiWrapper({
      endPoint: homePageRevisionEndPoint.getHomePageRevisions,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default homePageAPI
